<template>
  <v-footer
      id="dashboard-core-footer"
  >
    <v-container>
      <v-row
          align="center"
          no-gutters
      >
        <v-col>
          <v-btn
              fab
              x-small
              @click="setDrawer(!drawer)"
          >
            <v-icon v-if="value">
              mdi-view-quilt
            </v-icon>

            <v-icon v-else>
              mdi-dots-vertical
            </v-icon>
          </v-btn>
        </v-col>

        <v-col
            :key="i"
            class="text-center mb-sm-0 mb-5"
            cols="auto"
            v-for="(link, i) in links"
        >
          <a
              :href="link.href"
              class="mr-0"
              rel="noopener"
              target="_blank"
              v-text="link.text"
          />
        </v-col>

        <v-spacer class="hidden-sm-and-down"/>

        <v-col
            cols="12"
            md="auto"
        >
          <div class="body-1 font-weight-light pt-6 pt-md-0 text-center">
            &copy; 2024, made with
            <v-icon size="18">
              mdi-heart
            </v-icon>
            by <a>PP</a>.
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import {mapState} from 'vuex'
import {eventBus} from "@/services/event-bus";

export default {
  name: 'DashboardCoreFooter',
  data: () => ({
    links: [
      {
        href: 'https://katarynka-ct.pl',
        text: 'katarynka-ct.pl',
      },
    ]
  }),
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['drawer']),
  },
  methods: {
    setDrawer() {
      eventBus.$emit('set-drawer', !this.value);
    }
  }
};
</script>

<style lang="sass">
#dashboard-core-footer
  a
    color: #3c4858
    font-size: .825rem
    font-weight: 500
    text-decoration: none
    text-transform: uppercase
</style>
